import { Route, Routes } from 'react-router-dom'

import Login from 'pages/Login'
import { PrivateRoutes, SharedRoutes } from './rutas'
import EnableTeacher from 'components/administracion/enableTeacher/EnableTeacher'
import PeriodSettings from 'components/administracion/periodo/PeriodSettings'
import Administracion from 'components/administracion/configuration/Administracion'
import Report from 'components/administracion/reports/Report'
import { EnableSubject } from 'components/administracion/enableSubject/EnableSubject'
import ModalNotification from 'components/teacher/home/ModalNotification'
import { NotificationTest } from 'components/teacher/instructions/NotificationTest'
import { Justification } from 'components/administracion/claim/Justification'
import Control from 'components/teacher/home/Control'
import ReportTeacher from 'components/teacher/report/ReportTeacher'
import Layout from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import LayoutNotificacion from 'components/LayoutNotificacion'
import PageNotFound from 'pages/PageNotFound'
import { useEffect } from 'react'
import { APISERVICE } from 'services/api.service'
import { clearLoginData, setUserData } from 'redux/states/authSlice'
import LoadingSection from 'pages/LoadingSection'
import Loading from 'pages/Loading'
import Home from 'pages/Home'
import LayoutDocente from 'components/teacher/home/LayoutDocente'
import { Ayuda } from 'pages/Ayuda'
import UserSettings from 'components/administracion/user/UserSettings'
import { clearTeacher } from 'redux/states/docente'

const sharedRoutes = [
    { path: SharedRoutes.AYUDA, element: <Ayuda /> },
    { path: '*', element: <PageNotFound /> },
]

const routesByUser = {
	administrador: [
		{
			element: <Layout />,
			children: [
				{ path: PrivateRoutes.INICIO, element: <Home /> },
				{ path: PrivateRoutes.ADMINISTRACION, element: <Administracion /> },
				{ path: PrivateRoutes.PERIODO, element: <PeriodSettings /> },
				{ path: PrivateRoutes.HABILITARDOCENTE, element: <EnableTeacher /> },
				{ path: `${PrivateRoutes.HABILITARMATERIA}/:id`, element: <EnableSubject /> },
				{ path: PrivateRoutes.REPORTES, element: <Report /> },
				{ path: PrivateRoutes.JUSTFICACIONES, element: <Justification /> },
				...sharedRoutes,
			],
		},
	],
	uti: [
		{
			element: <Layout />,
			children: [
				{ path: PrivateRoutes.INICIO, element: <Home /> },
				{ path: PrivateRoutes.REPORTES, element: <Report /> },
				{ path: PrivateRoutes.JUSTFICACIONES, element: <Justification /> },
                { path: PrivateRoutes.SETTINGS, element: <UserSettings /> },
				...sharedRoutes,
			],
		},
	],
	docente: [
		{
			element: <Layout />,
			children: [
				{
					element: <LayoutDocente />,
					children: [
						{ path: PrivateRoutes.HOMETEACHER, element: <Control /> },
						{ path: PrivateRoutes.REPORTETEACHER, element: <ReportTeacher /> },
                        { path: PrivateRoutes.SETTINGS, element: <UserSettings /> },
						...sharedRoutes,
					],
				},
			],
		},
		{
			element: <LayoutNotificacion />,
			children: [
				{ path: PrivateRoutes.CONTROLPERMANENCIA, element: <ModalNotification /> },
				{ path: PrivateRoutes.CONTROLPERMANENCIATEST, element: <NotificationTest /> },
			],
		},
	],
	'': [],
}

export default function Router() {
	const dispatch = useDispatch()
	const { isLogged, user, roles } = useSelector((state) => state.auth)
	const role = roles.length > 0 ? roles[0] : ''

	useEffect(() => {
		if (isLogged) {
			loadUserData()
		}
	}, [isLogged])

	const loadUserData = async () => {
		const response = await APISERVICE.get('usuario/get-data')
		if (response.success) {
			dispatch(setUserData(response.userData, response.authData.roles))
		} else {
            dispatch(clearLoginData())
            dispatch(clearTeacher())
        }
	}

	const buildRoutes = (route, index) => {
		const { children, ...props } = route
		return children ? (
			<Route key={index} {...props}>
				{children.map(buildRoutes)}
			</Route>
		) : (
			<Route key={index} {...props} />
		)
	}

	return isLogged ? (
		user ? (
			<Routes>
				<Route path='/' element={<LoadingSection />} />
				{routesByUser[role].map(buildRoutes)}
			</Routes>
		) : (
			<Loading />
		)
	) : (
		<Routes>
			<Route element={<Layout />}>
				<Route path='*' element={<Login />} />
			</Route>
		</Routes>
	)
}
